import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"task-location"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M18.75 22.5C18.75 22.5 22.5 20.0035 22.5 16.75C22.5 14.6789 20.8211 13 18.75 13C16.6789 13 15 14.6789 15 16.75C15 20.0035 18.75 22.5 18.75 22.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 6V4H4V22H13M8 6H16M8 6V2H16V6M16 6V4H20V9.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M18.5 17H19M22.5 16.75C22.5 20.0035 18.75 22.5 18.75 22.5C18.75 22.5 15 20.0035 15 16.75C15 14.6789 16.6789 13 18.75 13C20.8211 13 22.5 14.6789 22.5 16.75Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TaskLocation = Vue.extend<IconProps>({
  name: 'TaskLocationIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'task-location',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default TaskLocation;
